"use strict";

module.exports = {
  initQuery: require('../methods/init-query'),
  resetQuery: require('../methods/reset-query'),
  initCustomFilters: require('../methods/init-custom-filters'),
  initOptions: require('../methods/init-options'),
  sortableClass: require('../methods/sortable-class'),
  sortableChevronClass: require('../methods/sortable-chevron-class'),
  display: require('../methods/display'),
  orderByColumn: require('../methods/order-by-column'),
  getHeading: require('../methods/get-heading'),
  getHeadingTooltip: require('../methods/get-heading-tooltip'),
  sortable: require('../methods/sortable'),
  serverSearch: require('../methods/server-search'),
  initOrderBy: require('../methods/init-order-by'),
  initDateFilters: require('../methods/init-date-filters'),
  setFilter: require('../methods/set-filter'),
  setPage: require('../methods/set-page'),
  setOrder: require('../methods/set-order'),
  initPagination: require('../methods/init-pagination'),
  filterable: require('../methods/filterable'),
  isTextFilter: require('../methods/is-text-filter'),
  isDateFilter: require('../methods/is-date-filter'),
  isListFilter: require('../methods/is-list-filter'),
  highlightMatch: require('../filters/highlight-matches'),
  formatDate: require('../filters/format-date'),
  hasDateFilters: require('../methods/has-date-filters'),
  applyFilters: require('../methods/apply-filters'),
  optionText: require('../filters/option-text'),
  render: require('../methods/render'),
  rowWasClicked: require('../methods/row-was-clicked'),
  setLimit: require('../methods/set-limit'),
  getOpenChildRows: require('../methods/get-open-child-rows'),
  dispatch: require('../methods/dispatch'),
  toggleChildRow: require('../methods/toggle-child-row'),
  childRowTogglerClass: require('../methods/child-row-toggler-class'),
  sendRequest: require('../methods/send-request'),
  getResponseData: require('../methods/get-response-data'),
  getSortFn: require('../methods/get-sort-fn'),
  initState: require('../methods/init-state'),
  updateState: require('../methods/update-state'),
  columnClass: require('../methods/column-class'),
  getName: require('../methods/get-name'),
  toggleColumn: require('../methods/toggle-column'),
  setUserMultiSort: require('../methods/set-user-multi-sort'),
  _cellClasses: require('../methods/cell-classes'),
  _setFiltersDOM: require('../methods/set-filters-dom'),
  _currentlySorted: require('../methods/currently-sorted'),
  _getChildRowTemplate: require('../methods/get-child-row-template'),
  _toggleColumnsDropdown: require('../methods/toggle-columns-dropdown'),
  _onlyColumn: require('../methods/only-column'),
  _onPagination: require('../methods/on-pagination'),
  _toggleGroupDirection: require('../methods/toggle-group-direction'),
  _getInitialDateRange: require('../methods/get-initial-date-range'),
  _setDatepickerText: require('../methods/set-datepicker-text'),
  _initialOrderAscending: require('../methods/initial-order-ascending'),
  dateFormat: require('../methods/date-format'),
  _setColumnsDropdownCloseListener: require('../methods/set-columns-dropdown-close-listener'),
  _getValue: require('../methods/get-value'),
  _getColumnName: require('../methods/get-column-name'),
  _shouldShowColumnOnInit: require('../methods/should-show-column-on-init')
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/mixins/methods.js
// module id = 1648
// module chunks = 64